import { send as sendOriginal } from '@core/js/hooks/socket';
import { IServerSendResponse } from '@core/js/hooks/socket/types';
import { TServerSendRequest } from '@interlayer/js/app/hooks/requestManager/types';
import {
    registerRequest,
    updateRequest,
    REQUEST_STATUSES,
    NOT_STORE_SERVER_IDS
} from '@interlayer/js/app/hooks/requestManager';

export * from '@core/js/hooks/socket';

export const createPromise = (request: TServerSendRequest) => {
    const promise = sendOriginal(request)
        .then((response: IServerSendResponse) => {
            updateRequest(request, REQUEST_STATUSES.success, { response });

            return Promise.resolve(response);
        })
        .catch((error: Record<string, unknown>) => {
            updateRequest(request, REQUEST_STATUSES.failed, { error });

            return Promise.reject(error);
        });
    const requestStatus = NOT_STORE_SERVER_IDS.includes(request.ID)
        ? REQUEST_STATUSES.notStore
        : !request?.responses ? REQUEST_STATUSES.withoutResponse : REQUEST_STATUSES.pending;

    updateRequest(request, requestStatus, { promise });

    return promise;
};

export const send = <RequestData = object>(request: TServerSendRequest<RequestData>, isIgnoreUserVerified?: boolean) => {
    const cashedRequest = registerRequest(request, isIgnoreUserVerified);

    switch (cashedRequest?.status) {
        case REQUEST_STATUSES.pending:
        case REQUEST_STATUSES.timeout:
        case REQUEST_STATUSES.success:
        case REQUEST_STATUSES.notVerified:
            return cashedRequest.promise;

        case REQUEST_STATUSES.failed:
            // eslint-disable-next-line no-case-declarations
            const timeoutPromise = new Promise((resolve) => {
                setTimeout(() => resolve(createPromise(request)), cashedRequest.timeout);
            });

            updateRequest(request, REQUEST_STATUSES.timeout, { promise: timeoutPromise });

            return timeoutPromise;

        default:
            break;
    }

    return createPromise(request);
};
